import { EntityType } from '@frontend/common';
import { EquipmentStateName, EquipmentType, IEquipment } from '@frontend/equipment/types';
import { DocType, IMAGE_MIME_TYPES, useBlobRepository, useDocumentRepository } from '@frontend/repository';

export class Equipment implements IEquipment {
    serial_number: string;
    owner_id?: string | null;
    type: EquipmentType | null;
    user_id?: string | null;
    state: EquipmentStateName;
    update_timestamp: string;
    product_id: string;
    workflow_id: string | null;
    id: string;
    account_id: string;
    creation_timestamp: string;
    delete_timestamp: string | null;
    future_state: EquipmentStateName | null;

    constructor(equipment: IEquipment) {
        this.serial_number = equipment.serial_number;
        this.owner_id = equipment.owner_id;
        this.type = equipment.type;
        this.user_id = equipment.user_id;
        this.state = equipment.state;
        this.update_timestamp = equipment.update_timestamp;
        this.product_id = equipment.product_id;
        this.workflow_id = equipment.workflow_id;
        this.id = equipment.id;
        this.account_id = equipment.account_id;
        this.creation_timestamp = equipment.creation_timestamp;
        this.delete_timestamp = equipment.delete_timestamp;
        this.future_state = equipment.future_state;
    }

    async getImage(documentRepository: ReturnType<typeof useDocumentRepository>): Promise<string | null> {
        let service = await documentRepository.getFiles(EntityType.PRODUCT, this.product_id);
        const image = service.getDocuments().find((d) => service.getType(d.id) === DocType.IMAGE);
        if (image) return await service.getUrl(image.id);
        return null;
    }

    async getBlobImage(blobRepository: ReturnType<typeof useBlobRepository>): Promise<string | null> {
        const info = await blobRepository.getBlob(this.account_id, EntityType.PRODUCT, this.product_id);
        if (info && IMAGE_MIME_TYPES.includes(info.mimeType)) return info.url;
        return null;
    }
}
